function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import firebase from 'firebase';
import { crudUserProfileTables } from '@/mixins/crud_userprofile_tables.js';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import ProjectsService from '@/apps/data-platform/services/master_data/projects_service';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import PaginationBasic from '@/components/PaginationBasic.vue';
export default {
  name: 'TableDetailPage',
  mixins: [crudUserProfileTables],
  components: {
    PaginationBasic: PaginationBasic
  },
  data: function data() {
    return {
      select_profile_user_tables: [],
      search: '',
      loadingBulk: false,
      showOnlyPending: false,
      select_areas: [],
      alert: false,
      dialogFlag: false,
      modalId: 'dp_userprofile_table',
      record_details: [],
      record_details_delete: [],
      profileFiltered: [],
      collapse_filter: false,
      access_type_options: [{
        value: 0,
        text: 'Read'
      }, {
        value: 1,
        text: 'Write'
      }],
      fields_details: [{
        key: 'project_name',
        label: this.traductor('tablas.project'),
        sortable: true,
        class: 'text-left',
        width: 200
      }, {
        key: 'dataset_name',
        label: this.traductor('tablas.dataset'),
        sortable: true,
        class: 'text-left',
        width: 200
      }, {
        key: 'table_name',
        label: this.traductor('tablas.table'),
        sortable: true,
        class: 'text-left inline-flex',
        width: 200
      }, {
        key: 'default_accesstime_months',
        label: this.traductor('tablas.months'),
        sortable: true,
        class: 'text-center'
      }, {
        key: 'accesstype_id',
        label: this.traductor('tablas.type'),
        sortable: true,
        class: 'text-center'
      }],
      headers2: [{
        value: 'project_name',
        text: this.traductor('tablas.project'),
        sortable: true,
        class: 'text-left',
        width: 200
      }, {
        value: 'dataset_name',
        text: this.traductor('tablas.dataset'),
        sortable: true,
        class: 'text-left',
        width: 300
      }, {
        value: 'table_name',
        text: this.traductor('tablas.table'),
        sortable: true,
        class: 'text-left',
        width: 300
      }, {
        value: 'default_accesstime_months',
        text: this.traductor('tablas.months'),
        sortable: true,
        class: 'text-center',
        width: '5%',
        align: 'center'
      },
      //{ value: 'accesstype_id', text: this.traductor('tablas.type'), sortable: true, class: 'text-center' , width: '10%', align: 'center'},
      {
        value: 'flag_active',
        text: 'Active',
        class: 'text-center',
        width: '5%',
        align: 'center'
      }, {
        value: 'actions',
        text: 'Acciones',
        class: 'text-center',
        width: '5%',
        align: 'center'
      }],
      domainList: [],
      projectListDict: [],
      firstChange: [],
      table_verification: 'You must validate if the table exists, Clic this icon to validate!',
      fileToUpload: '',
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      key_table_detail: 1,
      source_list: [{
        value: "bigquery",
        text: 'Bigquery'
      }, {
        value: "synapse",
        text: 'Synapse'
      }],
      pagination2: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isTableauActive', 'isPowerBIActive', 'isDataStudioActive', 'isSynapseActive'])), {}, {
    headers: function headers() {
      return [{
        value: 'area_description',
        text: this.traductor('tablas.area'),
        sortable: true,
        class: 'text-left'
      }, {
        value: 'userprofile_description',
        text: this.traductor('tablas.profile'),
        sortable: true,
        align: "center"
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        align: "center"
      }];
    },
    filteredHeaders: function filteredHeaders() {
      if (this.isSynapseActive) {
        return [{
          value: 'source',
          text: 'Source',
          sortable: true,
          class: 'text-left',
          width: 200
        }].concat(_toConsumableArray(this.headers2));
      } else {
        return this.headers2;
      }
    },
    texts: function texts() {
      return {
        area: this.traductor('tablas.area'),
        profile: this.traductor('tablas.profile')
      };
    },
    modalName: function modalName() {
      return this.traductor('menu.dp.up_table_details');
    },
    validatedCount: function validatedCount() {
      return this.record_details.filter(function (r) {
        return r.table_verified === true;
      }).length;
    },
    pendingCount: function pendingCount() {
      return this.record_details.filter(function (r) {
        return r.table_verified !== true;
      }).length;
    },
    filteredRecordDetails: function filteredRecordDetails() {
      var items = this.showOnlyPending ? this.record_details.filter(function (r) {
        return r.table_verified !== true;
      }) : this.record_details;
      if (!this.search) return items;
      var q = this.search.toLowerCase();
      return items.filter(function (r) {
        return r.project_name && r.project_name.toLowerCase().includes(q) || r.dataset_name && r.dataset_name.toLowerCase().includes(q) || r.table_name && r.table_name.toLowerCase().includes(q);
      });
    },
    rows: function rows() {
      return this.select_profile_user_tables.length;
    }
  }),
  created: function created() {
    this.getAreas();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getRecords: function getRecords() {
      var _this = this;
      this.parametros = {
        domain: 'intercorp.com.pe'
      };
      this.toggleBusy();
      UserProfileService.getUserProfiles(this.parametros).then(function (data) {
        _this.toggleBusy();
        console.log(data);
        _this.select_profile_user_tables = data.data;
        _this.firstChange = Object.assign([], _this.select_profile_user_tables);
      }, function (err) {
        _this.toggleBusy();
        console.log(err);
      });
    },
    getAreas: function getAreas() {
      var _this2 = this;
      this.parametros = {
        domain: 'intercorp.com.pe'
      };
      UserProfileService.getAreas(this.parametros).then(function (data) {
        console.log(data);
        // this.select_areas = data.data;
        data.data.forEach(function (element) {
          _this2.select_areas.push({
            value: element.area_id,
            text: element.area_description
          });
        });
      }, function (err) {
        console.og(err);
      });
    },
    getProjects: function getProjects() {
      var _this3 = this;
      ProjectsService.getAllProjects().then(function (response) {
        _this3.domainList = response.data.domains;
        _this3.projectListDict = [];
        response.data.projects[window.userInfo.domain].forEach(function (x) {
          _this3.projectListDict.push({
            'value': x,
            'text': x
          });
        });
      });
    },
    cambiarDatosTabla: function cambiarDatosTabla(index, type) {
      if (this.firstChange[index] !== undefined) {
        if (this.firstChange[index].record_id !== undefined) {
          if ((this.firstChange[index].project_name !== this.record_details[index].project_name || this.firstChange[index].dataset_name !== this.record_details[index].dataset_name || this.firstChange[index].table_name !== this.record_details[index].table_name) && this.record_details[index].table_verified != true) {
            console.log("change data");
            // console.log("Type: " + type)
            this.record_details[index].changed = true;
            this.record_details[index].table_verified = false;
            this.record_details[index].error = this.table_verification;
          } else {
            // console.log("Type: " + type)
            /*this.record_details[index].changed = false
            this.record_details[index].table_verified = true
            this.record_details[index].error = ''*/
          }
        }
      }
    },
    enterValidateTable: function enterValidateTable(event, item, index) {
      if (event.which !== 13) {
        // console.log(event.which, item);
        return;
      }
      this.validarTabla(item, index);
    },
    validarTabla: function validarTabla(item, index) {
      var _this4 = this;
      // console.log("index: " + index);
      // if (event) event.preventDefault();
      // if (event) event.stopPropagation();
      this.$nextTick(function () {
        if (!(item.project_name && item.dataset_name && item.table_name)) {
          tasks.toast.error('No table to validate!');
          // this.$toast.warning("No table to validate!")
          return;
        }
        if (item.record_id) {
          _this4.record_details[index].changed = true;
        }
        item.table_verified = null;
        console.log(item.table_verified);
        _this4.key_table_detail += 1;
        item.error = '';
        var id = "".concat(item.project_name, ":").concat(item.dataset_name, ".").concat(item.table_name);
        /* const defaultParams = {
          allDomains: false,
          domain: window.userInfo.domain,
          approval_flow: true,
          query: `name: ${id} tag:{project_id}.tpl_tables.env=prod`,
          searchWithTags: true,
          pageSize: 10,
          email:	window.userInfo.email
        }*/
        var defaultParams = {
          values: {
            project_name: item.project_name,
            dataset_name: item.dataset_name,
            table_name: item.table_name,
            source: item.source ? item.source : "bigquery"
          }
        };
        _this4.toggleBusy();
        UserProfileService.validateTable(defaultParams).then(function (response) {
          _this4.toggleBusy();
          console.log(response);
          if (response && response.code === 200) {
            if (response.success) {
              console.log("Existe tabla 1");
              item.table_verified = true;
              console.log(item.error, item.table_verified);
            } else {
              item.table_verified = false;
              item.error = "".concat(id, " does not exists or it is not in 'prod' enviroment yet.");
            }
          } else if (response && response.code === 400) {
            console.log(response.code, response.message);
          }
          _this4.key_table_detail += 1;
          // callback && callback(response)
        }).then(function () {
          if (item.table_verified) {
            console.log("Existe tabla 2");
            // this.openProfilingModal(this.recordMetadata)
          } else {
            item.table_verified = false;
            // this.dismissCountDown = this.dismissSecs
            // console.log(id);
            item.error = "".concat(id, " does not exists or it is not in 'prod' enviroment yet.");
          }
          item.table_name = item.table_name + '[@@@@@]';
          item.table_name = item.table_name.replace('[@@@@@]', '');
          console.log(item);
          _this4.key_table_detail += 1;
        }).catch(function (e) {
          _this4.toggleBusy();
          utils.printError(e);
          //self.messageEmptyList = 'The request was interrupted, try again'
        });
      });
    },
    putRecord: function putRecord() {
      var _this5 = this;
      var record_details = this.pushDetails();
      var toCreate = record_details.filter(function (rec) {
        return rec.record_id === undefined;
      });
      record_details = record_details.filter(function (rec) {
        return rec.record_id !== undefined;
      });
      var record_detail_original = null;
      var change_details = [];
      var _iterator = _createForOfIteratorHelper(record_details),
        _step;
      try {
        var _loop = function _loop() {
            var record_detail = _step.value;
            record_detail_original = _this5.record_details_original.filter(function (rec) {
              return rec.record_id === record_detail.record_id;
            })[0];
            var _this5$getValuesToUpd = _this5.getValuesToUpdate(record_detail, record_detail_original);
            toSave = _this5$getValuesToUpd.toSave;
            oldValues = _this5$getValuesToUpd.oldValues;
            if (Object.keys(oldValues).length) {
              change_details.push({
                toSave: toSave,
                oldValues: oldValues
              });
            }
          },
          toSave,
          oldValues;
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var toDelete = [];
      var _iterator2 = _createForOfIteratorHelper(this.record_details_original),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var record = _step2.value;
          if (!record_details.filter(function (rec) {
            return rec.record_id === record.record_id;
          }).length) {
            toDelete.push({
              record_id: record.record_id
            });
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (!change_details.map(function (rec) {
        return Object.keys(rec.oldValues).length;
      })) {
        return new Promise(function (resolve, reject) {
          resolve();
          return false;
        });
      }
      var changes = {
        toUpdate: change_details,
        toCreate: toCreate,
        toDelete: toDelete,
        area_id: this.record.area_id,
        userprofile_id: this.record.userprofile_id
      };
      return appApis.putUserprofileTable(changes).then(function () {
        return true;
      });
    },
    postRecord: function postRecord() {
      var record_details = this.pushDetails();
      return appApis.postRecord(this.modalId, record_details).then(function () {
        return true;
      });
    },
    pushDetails: function pushDetails() {
      var record_details = [];
      var _iterator3 = _createForOfIteratorHelper(this.record_details),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var record = _step3.value;
          record_details.push(_objectSpread(_objectSpread({}, record), this.record));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return record_details;
    },
    handleSubmit: function handleSubmit() {
      var _this6 = this;
      if (!this.checkFormValidity()) {
        return;
      }
      var to_create = this.record_details.filter(function (x) {
        return x.record_id == null;
      });
      var to_edit = this.record_details.filter(function (x) {
        return x.record_id != null && x.changed == true;
      });
      var to_delete = this.record_details_delete;
      if (to_create.length == 0 && to_edit.length == 0 && to_delete.length == 0) {
        tasks.toast.error('No hay cambios para guardar.');
        return;
      }
      // verificar que se hayan validado las tablas
      // primero los que son insert
      if (to_create.length > 0) {
        var count = to_create.filter(function (x) {
          return x.table_verified == true;
        });
        if (count.length != to_create.length) {
          tasks.toast.error('You should validate if tables exists, before register it.');
          // alert("You should validate if tables exists, before register it.");
          return;
        }
      }
      if (to_edit.length > 0) {
        var _count = to_edit.filter(function (x) {
          return x.table_verified == true;
        });
        if (_count.length != to_edit.length) {
          tasks.toast.error('You should validate if tables exists, before edit it.');
          // alert("You should validate if tables exists, before edit it.");
          return;
        }
      }
      var data = {
        domain: 'intercorp.com.pe',
        values: {
          'creator_user': window.userInfo.email,
          'area_id': this.record.area_id,
          'userprofile_id': this.record.userprofile_id,
          to_create: to_create,
          to_edit: to_edit,
          to_delete: to_delete
        }
      };
      this.busy2 = !this.busy2;
      UserProfileService.crudTables(data).then(function (datos) {
        console.log(datos);
        _this6.busy2 = !_this6.busy2;
        // this.$bvModal.hide(this.modalId)
        if (datos.success) {
          tasks.toast.success('Successful request!');
        }
        _this6.$refs['dialog'].onClose();
        _this6.getAreas();
        // this.$toast.success("Successful request!")
        _this6.loadTables();
      }, function (err) {
        _this6.busy2 = !_this6.busy2;
        // this.$bvModal.hide(this.modalId)
      });
    },
    addItem: function addItem() {
      this.record_details.push({
        flag_active: this.mode === 'edit',
        table_verified: false,
        error: this.table_verification,
        source: 'bigquery'
      });
    },
    // removeItem(data) {
    //   console.log('remove item: ', data)
    //   const record_details = []
    //   let index = 0
    //   console.log('record details before remove: ', this.record_details)
    //   for (const detail of this.record_details) {
    //     if (data.index !== index) {
    //       record_details.push(detail)
    //     } else {
    //       if (detail.record_id) { this.record_details_delete.push(detail) }
    //     }
    //     index += 1
    //   }
    //   this.record_details = record_details
    // },
    removeItem: function removeItem(item) {
      var index = this.record_details.indexOf(item);
      if (index === -1) return;
      this.record_details.splice(index, 1);
      this.firstChange.splice(index, 1);
      if (item.record_id) {
        this.record_details_delete.push(item);
      }
    },
    clearFieldsDetail: function clearFieldsDetail() {
      this.fields_details = this.fields_details.filter(function (rec) {
        return !['actions', 'flag_active'].includes(rec.key);
      });
      if (['edit', 'view'].includes(this.mode)) {
        if (!this.fields_details.filter(function (rec) {
          return rec.key === 'flag_active';
        }).length) {
          this.fields_details.push({
            key: 'flag_active',
            label: 'Active',
            sortable: true,
            class: 'text-center'
          });
        }
      }
      if (['edit', 'create'].includes(this.mode)) {
        if (!this.fields_details.filter(function (rec) {
          return rec.key === 'actions';
        }).length) {
          this.fields_details.push({
            key: 'actions',
            label: ' ',
            sortable: true,
            class: 'text-center'
          });
        }
      }
    },
    checkFormValidity: function checkFormValidity() {
      var valid = this.$refs.form.validate();
      /* if (this.mode === 'create') {
        const record_filtered = this.select_profile_user_tables.filter(
          rec => rec.area_id === this.record.area_id && rec.userprofile_id === this.record.userprofile_id
        )
        if (record_filtered.length) {
          this.dismissCountDown = this.dismissSecs
          this.dangerMessage = 'Profile table (area, profile) already exists'
          return false
        }
      }*/
      return valid;
    },
    laucherBulkUpload: function laucherBulkUpload() {
      this.$refs.btnBulkUpload.click();
    },
    uploadFile: function uploadFile(event) {
      var _this7 = this;
      this.fileToUpload = '';
      console.log(event);
      if (event.target.files) {
        var file = event.target.files[0];
        // validar
        this.getFileBase64(file);
        setTimeout(function () {
          // console.log(this.fileToUpload);
          var subir = false;
          if (_this7.fileToUpload) {
            subir = true;
            var params = {
              data: _this7.fileToUpload
            };
            _this7.loadingBulk = true;
            UserProfileService.uploadValidateTables(params).then(function (response) {
              _this7.loadingBulk = false;
              console.log(response);
              _this7.$refs.btnBulkUpload.value = null;
              if (response.success) {
                if (response.data) {
                  var duplicates_here = '';
                  response.data.forEach(function (x) {
                    var count = 0;
                    _this7.record_details.forEach(function (y) {
                      if (x.project_name == y.project_name && x.dataset_name == y.dataset_name && x.table_name == y.table_name) {
                        count++;
                      }
                    });
                    if (count == 0) {
                      if (!x.source) x.source = 'bigquery';
                      _this7.record_details.push(x);
                    } else {
                      if (duplicates_here != '') {
                        duplicates_here += ', ';
                      }
                      duplicates_here += x.project_name + ':' + x.dataset_name + '.' + x.table_name;
                    }
                  });
                  // this.record_details = this.record_details.concat(response.data)
                  if (response.message != 'ok') {
                    _this7.dismissCountDown = _this7.dismissSecs;
                    _this7.dangerMessage = response.message + (duplicates_here != '' ? ', ' + duplicates_here : '');
                  } else {
                    if (duplicates_here != '') {
                      _this7.dismissCountDown = _this7.dismissSecs;
                      _this7.dangerMessage = 'Duplicate tables: ' + duplicates_here;
                    }
                  }
                } else {
                  _this7.dismissCountDown = _this7.dismissSecs;
                  _this7.dangerMessage = response.message;
                  tasks.toast.error(response.message);
                  // this.$toast.error(response.message)
                }
              }
            }, function (err) {
              _this7.loadingBulk = false;
              _this7.$refs.btnBulkUpload.value = null;
            });
          } else {}
        }, 500);
      }
    },
    getFileBase64: function getFileBase64(file) {
      var _this8 = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        _this8.fileToUpload = reader.result.split('base64,')[1];
      };
      reader.onerror = function () {
        _this8.fileToUpload = '';
      };
    },
    downloadTemplate: function downloadTemplate() {
      firebase.storage().ref('templates_xlsx/plantilla_user_profiles.xlsx').getDownloadURL().then(function (url) {
        // `url` is the download URL for 'images/stars.jpg'

        // This can be downloaded directly:
        window.open(url);
      }).catch(function (error) {
        // Handle any errors
      });
    }
  }
};